import React from "react";

const ProductReview = ({ reviews }) => {
  if (!reviews) {
    return;
  }
  return (
    <section className="product-review">
      {reviews.map((review) => {
        return (
          <div
            className="product-review__item"
            key={review.review_id}
            itemProp="review"
            itemType="https://schema.org/Review"
            itemscope
          >
            <div className="product-review__item__detail">
              <div>
                <div>
                  <strong
                    itemProp="author"
                    itemType="https://schema.org/Person"
                    itemscope
                  >
                    <meta itemProp="name" content={review.nickname} />
                    {review.nickname}
                  </strong>
                  <span>{review.created_at}</span>
                </div>
                <div
                  className="product-review__item__rating"
                  itemProp="reviewRating"
                  itemType="https://schema.org/Rating"
                  itemscope
                >
                  <meta itemProp="ratingValue" content={review.value} />
                  <meta itemProp="bestRating" content="5" />
                  {[...Array(5)].map((star, i) => {
                    return review.value >= i + 1 ? (
                      <i className="rating-star active" key={i}></i>
                    ) : (
                      <i className="rating-star" key={i}></i>
                    );
                  })}
                </div>
              </div>
              <p>{review.title}</p>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default ProductReview;
